import { v4 as UUID } from 'uuid';
import apis from '../app/apis';
import cts from '../app/cts';
import store from '../configureStore';
import { setDistrictsArray } from '../helpers';
import {
  getCampaignActiveStatus,
  // setCampaignPrompt
} from '../pages/Campaign/redux/actions';
import setWwtkData from '../pages/Resources/redux/actions';
import { setCollectionSchedule } from '../pages/ZoneSetupScreens/utils';

import {
  plugin, config, zone, education
} from '../redux/actions';

const { dispatch } = store.store;

const {
  setUuid,
  setPluginId,
  setProjectId,
  setEncodePluginId,
} = plugin;

const {
  setLangs,
  setTitle,
  setCountryCode,
  setDistrictId,
  setLocalityId,
  setDefaultLang,
  setSelectedLang,
  setSearchAtFirst,
  setTemplateColour,
  setIsMultiDistrict,
  setIsActive,
  setWebappConfiguration,
  setShouldSeeDistrictSelector,
} = config;

const {
  setZoneAry,
  setZoneStr,
  setCountryName,
} = zone;

const {
  setEducationData
} = education;

const downloadPackage = async (pluginId) => {
  try {
    const { data, status } = await cts('post', apis.getPluginDetails(), pluginId);

    if (
      !data
      && !Object.keys(data).length
      && status !== 200
    ) throw new Error('There was a problem in downloading the plugin data.');

    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e.message);
  }
};

const trackerSystem = async (pluginId) => {
  try {
    const { data, status } = await cts('post', apis.sendPluginTracker(), pluginId);

    if (
      !data
      && !Object.keys(data).length
      && status !== 200
    ) throw new Error('There was a problem in downloading the plugin data.');
  } catch (e) {
    throw new Error(e);
  }
};

const convertLangLabel = (langs) => {
  if (!langs) return {};
  const lngs = Object.entries(langs).map((lang) => {
    const { lang_cd, display_nm } = lang[1];
    return {
      label: display_nm.replace(/Australian|British|Canadian|American|New Zealand|\(default\)/ig, '').trim(),
      lang_cd
    };
  });
  return lngs;
};

const Setup = async (pluginID) => {
  try {
    const { plugin, config, zone } = store.store.getState();
    const { uuid, projectId, storeDistricts } = plugin;
    const { zoneStr } = zone;
    const { selectedLang, districtId: district } = config;

    const pluginPackage = await downloadPackage({ plugin_id: pluginID, lang_cd: selectedLang || 'en' });

    if (
      !pluginPackage
      && !Object.keys(pluginPackage).length
    ) throw new Error('There was a problem in downloading the package data.');

    // Rehydrated and has data
    if (district && projectId && zoneStr) await setCollectionSchedule(zoneStr);

    dispatch(setEncodePluginId(pluginID));
    if (!uuid) {
      dispatch(setUuid(UUID()));
    }

    const {
      langs = [],
      title = '',
      plugin_id = '',
      project_id = '',
      country_nm = '',
      wwtk_items = {},
      custom_URL = '',
      country_cd = 'CA',
      tab_properties = {},
      template_colour = '',
      default_language = 'en_US',
      districts: rawDistricts = [],
      // webapp_campaign_prompt = null,
      adde_search_for_district_detect = false,
      is_active = true
    } = pluginPackage;
    if (
      Object.keys(tab_properties).length
      && tab_properties.custom_js
    ) {
      // eslint-disable-next-line no-eval
      eval(`(async () => {${tab_properties.custom_js.replace(/\n/ig, '')}})()`);
    }

    // event tracker system: for getting clients URL
    await trackerSystem({ plugin_url: custom_URL, url: window.location.href });

    /* Check for multi districts */
    const isMultiDistrict = (rawDistricts && rawDistricts.length > 1) || false;
    dispatch(setIsMultiDistrict(isMultiDistrict));

    /** Set country code */
    dispatch(setCountryCode(country_cd || 'CA'));
    dispatch(setIsActive(is_active));
    /* Determines if all the zone setup options are equal to address-search */
    const shouldNotSeeDistrictSelector = rawDistricts
      .map(({ prompts }) => prompts.length && prompts[0].zoneSelectOptions)
      .every(({ search }) => !!(search));
    if (isMultiDistrict) dispatch(setShouldSeeDistrictSelector(!shouldNotSeeDistrictSelector));

    /* Check for zone setup search at the beginning of the webapp */
    if (
      !zoneStr
      // && searchAtFirst
    ) {
      dispatch(setSearchAtFirst(adde_search_for_district_detect));
    }

    /**
     * First transform the districts from array to object
     * second find out if we select district before or not
     */
    const districts = rawDistricts.reduce((prev, cur) => {
      const newItem = prev;
      newItem[cur.district_id] = cur;
      return newItem;
    }, {});
    const districtId = setDistrictsArray(
      districts,
      rawDistricts.length === 1 // OR if it's single district
        ? Object.keys(districts)[0] // use the first district
        : district,
      tab_properties.has_calendar

    );

    if (
      isMultiDistrict
      && (
        Object.keys(districts).length !== Object.keys(storeDistricts).length
        || JSON.stringify(districts) !== JSON.stringify(storeDistricts)
      )
    ) {
      dispatch(setZoneStr(''));
      dispatch(setZoneAry([]));
      dispatch(setDistrictId(''));
      dispatch(setLocalityId(''));
      dispatch(setSelectedLang(default_language || 'en_US'));
      // Setup(pluginID);
    }

    if (
      !isMultiDistrict
      && (
        Object.keys(districts).length !== Object.keys(storeDistricts).length
        || JSON.stringify(districts) !== JSON.stringify(storeDistricts)
      )
    ) {
      dispatch(setZoneStr(''));
      dispatch(setZoneAry([]));
    }

    if (
      langs
      && langs.length
    ) dispatch(setLangs(convertLangLabel(langs)));

    /**
     * Set WWTK data
     */
    if (Object.keys(wwtk_items).length) dispatch(setWwtkData(wwtk_items));

    dispatch(setTitle(title));
    dispatch(setPluginId(plugin_id));
    dispatch(setProjectId(project_id));
    dispatch(setCountryName(country_nm || ''));
    dispatch(setDefaultLang(default_language));
    dispatch(setTemplateColour(template_colour));
    dispatch(setWebappConfiguration(tab_properties));

    /**
    * Set Education tab data for selected district
    */

    if (districtId) {
      dispatch(setEducationData(
        pluginPackage.districts
          .find((item) => item.district_id === districtId).education_tab_elements
      ));
    }

    /**
     * Check for active campaign
     */
    // if (webapp_campaign_prompt) dispatch(setCampaignPrompt(webapp_campaign_prompt));
    if (districtId) dispatch(getCampaignActiveStatus(project_id, districtId));

    return Promise.resolve('done');
  } catch (e) {
    return Promise.reject(e.message);
  }
};

export default Setup;
